import React, { useState } from "react";
import Sidebar from "./Sidebar";

const SIDEBAR_WIDTH = 220;
const SIDEBAR_COLLAPSED_WIDTH = 60;

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const sidebarWidth = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
        width={sidebarWidth}
      />
      <main
        style={{
          flex: 1,
          marginLeft: `${sidebarWidth}px`,
          minHeight: "100vh",
          transition: "margin-left 0.2s ease-in-out",
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
